import { gql } from '@apollo/client';

const HAS_USER_REACHED_EVENTS_LIMIT = gql`
  query HasUserReachedEventsLimit($userId: Int!, $year: Int!) {
    hasUserReachedEventsLimit(userId: $userId, year: $year)
  }
`;

export default HAS_USER_REACHED_EVENTS_LIMIT;
